import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadSvg = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 17, viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 15H14V17H0V15Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M3.41 6.59L2 8L7 13L12 8L10.59 6.59L8 9.17V0H6V9.17L3.41 6.59Z", fill: "white" }));
const ForwardRef = forwardRef(SvgDownloadSvg);
export { ForwardRef as ReactComponent };
